"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customTheme = exports.customPalette = void 0;
var material_1 = require("@mui/material");
var lodash_1 = require("lodash");
exports.customPalette = {
    component: {
        answerSelectedColor: 'rgb(134, 134, 134)',
        answerUnselectedColor: 'rgb(225, 225, 225)',
        continueButtonColor: 'rgb(134, 134, 134)',
        continueButtonHoverColor: 'rgb(107, 107, 107)',
        backButtonColor: 'rgb(237,237,237)',
        backButtonHoverColor: 'rgb(223,223,223)',
        progressBarFilledColor: 'rgb(134, 134, 134)',
        progressBarUnfilledColor: 'rgb(247,247, 247)',
        scrollIndicatorColor: 'rgb(134, 134, 134)',
    },
    background: {
        answerBackgroundColor: 'rgb(251, 251, 251)',
        secondaryBackgroundColor: 'rgb(247, 247, 247)',
        widgetBackgroundColor: 'rgba(0, 0, 0, 0)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(0, 0, 0)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var filters = {
    darken: {
        gentle: 0.1,
        medium: 0.3,
        harsh: 0.5,
    },
    lighten: {
        gentle: 0.1,
        medium: 0.3,
        strong: 0.7,
        harsh: 0.9,
        extreme: 0.95,
    },
    opacity: {
        gentle: 0.8,
        light: 0.4,
        harsh: 0.05,
    },
};
var spacing = {
    base: '1rem',
    reset: '0',
    tiny: '0.3rem',
    little: '0.45rem',
    small: '0.6rem',
    petite: '0.688rem',
    smedium: '1.063rem',
    medium: '1.2rem',
    moderate: '1.25rem',
    ample: '1.751rem',
    large: '2.5rem',
    huge: '3rem',
    massive: '4rem',
};
var border = {
    width: {
        thin: 1,
        medium: 2,
    },
    radius: 4,
};
var fontSize = {
    tiny: 11,
    little: 12,
    mini: 13,
    small: 14,
    compact: 15,
    medium: 16,
    hefty: 17,
    swoll: 18,
    large: 20,
    big: 22,
    huge: 24,
};
var lineHeight = {
    small: '1.2',
    medium: '1.5',
};
var multiplyAndRoundUpToNearestInt = function (value, multiplier) {
    return Math.ceil(value * multiplier);
};
var getFontSizesWithOriginalAndMultipliedValues = function (multiplier) {
    var fontSizesWithOriginal = {};
    Object.keys(fontSize).forEach(function (key) {
        var value = fontSize[key];
        fontSizesWithOriginal["original".concat(key.charAt(0).toUpperCase() + key.slice(1))] = value;
        fontSizesWithOriginal[key] = multiplyAndRoundUpToNearestInt(value, multiplier);
    });
    return fontSizesWithOriginal;
};
var themeCreator = function (palette, fontFamily, fontSizeMultiplier) {
    if (palette === void 0) { palette = exports.customPalette; }
    if (fontFamily === void 0) { fontFamily = "'Arial', sans-serif"; }
    if (fontSizeMultiplier === void 0) { fontSizeMultiplier = 1; }
    var processedFontSizes = getFontSizesWithOriginalAndMultipliedValues(fontSizeMultiplier);
    var boxShadow = {
        light: 'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px',
        timid: "0px 2px 5px rgba(33, 33, 33, 0.1)",
        medium: 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px',
        heavy: "rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px",
        fierce: "0px 4px 10px rgba(33, 33, 33, 0.2)",
        error: "0 0 0 1px ".concat(palette.status.error),
        primary: "0 0 0 1px ".concat(palette.component.answerSelectedColor),
        navigation: {
            primary: '1px 2px 5px 1px rgba(0, 0, 0, 0.25)',
            secondary: '2px 4px 10px 1px rgba(0, 0, 0, 0.4)',
        },
    };
    var customTheme = (0, material_1.createTheme)({
        palette: {
            primary: {
                main: palette.component.answerSelectedColor,
            },
            secondary: {
                main: palette.component.continueButtonColor,
            },
        },
        typography: {
            fontFamily: fontFamily,
        },
        // TODO: clean up breakpoints and possibly remove original
        // mat ui xs etc values following tile layout changes.
        breakpoints: {
            values: {
                xs: 0,
                mobileSmall: 280,
                mobileMedium: 310,
                mobileLarge: 330,
                sm: 430,
                tabletSmall: 500,
                md: 668,
                tabletMedium: 680,
                desktopSmall: 708,
                desktopMedium: 900,
                desktopLarge: 1080,
                lg: 1280,
                xl: 1920,
            },
        },
        components: {
            MuiInput: {
                styleOverrides: {
                    underline: {
                        '&:hover:not($disabled):before': {
                            borderBottomColor: palette.component.answerUnselectedColor,
                            borderBottomWidth: border.width.thin,
                        },
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        width: '100%',
                        display: 'flex',
                        position: 'relative',
                        boxSizing: 'border-box',
                        textAlign: 'left',
                        alignItems: 'center',
                        paddingTop: 6,
                        paddingBottom: 6,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        fontSize: processedFontSizes.medium,
                        justifyContent: 'flex-start',
                        textDecoration: 'none',
                        '&:focus': {
                            backgroundColor: 'unset',
                        },
                        '@media (hover: hover)': {
                            '&:hover': {
                                backgroundColor: (0, material_1.lighten)(palette.component.answerSelectedColor, filters.lighten.extreme),
                            },
                        },
                        '&.Mui-selected': {
                            backgroundColor: (0, material_1.lighten)(palette.component.answerSelectedColor, filters.lighten.extreme),
                        },
                        '@media (min-width:430px)': {
                            minHeight: 'auto',
                        },
                    },
                    gutters: {
                        paddingLeft: 16,
                        paddingRight: 16,
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '80%',
                        height: '100%',
                    },
                    shrink: {
                        maxWidth: '120%',
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        fontSize: processedFontSizes.compact,
                    },
                },
            },
            MuiTouchRipple: {
                styleOverrides: {
                    ripple: {
                        color: palette.component.answerSelectedColor,
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        color: palette.text.primaryTextColor,
                    },
                },
            },
        },
    });
    var theme = {
        mvf: {
            border: border,
            boxShadow: boxShadow,
            fontSize: processedFontSizes,
            filters: filters,
            lineHeight: lineHeight,
            palette: palette,
            spacing: spacing,
            brandLogoName: 'expertMarket',
            table: {
                row: {
                    height: '1.5rem',
                },
                column: {
                    width: '5.0rem',
                },
            },
            typography: {
                p: {
                    size: '1rem',
                },
                h1: {
                    size: '2rem',
                    icon: '3rem',
                },
                h2: {
                    size: '1.5rem',
                    icon: '2.5rem',
                },
                h3: {
                    size: '1.2rem',
                    icon: '2rem',
                },
                h4: {
                    size: '0.96rem',
                    icon: '1.6rem',
                },
                h5: {
                    size: '0.78rem',
                    icon: '1.3rem',
                },
                h6: {
                    size: '0.6rem',
                    icon: '1rem',
                },
                subheader: {
                    size: '1.5rem',
                    icon: '2.5rem',
                    fontFamily: fontFamily,
                },
                button: {
                    large: '1.1rem',
                },
                weight: {
                    thin: 300,
                    medium: 400,
                    thick: 700,
                },
                fontFamily: fontFamily,
            },
        },
    };
    return (0, lodash_1.merge)(customTheme, theme);
};
exports.customTheme = themeCreator();
exports.default = themeCreator;
//# sourceMappingURL=themeCreator.js.map